import { DataTableDashboard } from "../data-table-dashboard"
import { SuperTeamDashboardRow } from "./super-team-dashboard-row";
import superTeamDashboardColumnsJson from '@/src/models/dashboard/super_teams/superTeamDashboardColumns.json'

type Lookup = { 
  label: string;
  value: string;
}

export class SuperTeamDashboard extends DataTableDashboard {
   // TODO: Are these lookups or need their own model?
  transplantCenters: Array<Lookup> = []; 
  organs: Array<Lookup> = [];
  organGroups: Array<Lookup> = [];
  assignableUsers: Array<Object> = [];
  statuses: Array<Lookup> = [];
  checklistStatuses: Array<Lookup> = [];

  apiRows: SuperTeamDashboardRow[] = [];
  visibleRows: SuperTeamDashboardRow[] = [];
  failedRows: Array<SuperTeamDashboardRow> = [];
  
  totalCount: null|Number;
  totalPages: null|number;
  currentPage: null|number;

  constructor() {
    super(superTeamDashboardColumnsJson);
  }

  setContent({rows, totalCount, totalPages, currentPage}: {
    rows: Array<Object>,
    totalCount: number,
    totalPages: number,
    currentPage: number
  }) {
    this.totalCount = totalCount;
    this.currentPage = currentPage;
    this.totalPages = totalPages;

    this.apiRows = [];
    this.visibleRows = [];
    this.failedRows = [];
    rows.forEach((r: any) => {
      // Initialize the row twice cause we need to keep two copies around. 
      this.apiRows.push(SuperTeamDashboardRow.buildFromAPI(r));
      this.visibleRows.push(SuperTeamDashboardRow.buildFromAPI(r));
    });
  }
}